<template>
  <div id="dashboard" class="section">
    <div class="is-size-4">
      <b>Wellbeing Assessments for Schools/Colleges</b>
    </div>
    <br />
    <b>Total Screenings</b>: {{ countTotal }}
    <!-- <span class="is-size-7">({{ this.asOf }})</span> -->
    <br />
    <br />
    <div class="columns">
      <div class="card column year2018">
        <div class="card-content">
          <h3 class="is-size-5"><b>2018</b></h3>
          Number of Screenings: {{ this.count2018 }}
        </div>
      </div>
      <div class="card column year2019">
        <div class="card-content">
          <h3 class="is-size-5"><b>2019</b></h3>
          Number of Screenings: {{ this.count2019 }}
        </div>
      </div>
      <div class="card column year2020">
        <div class="card-content">
          <h3 class="is-size-5"><b>2020</b></h3>
          Number of Screenings: {{ this.count2020 }}
        </div>
      </div>
    </div>
    <br />
    <h3 class="is-size-4"><b>2019</b></h3>
    <br />
    <div class="columns is-multiline">
      <div class="card column is-6 quarter" v-for="quarter in quarters" :key="quarter.name">
        <div class="card-content">
          <h3 class="is-size-5">
            <b>{{ quarter.name }}</b>
          </h3>
          Number of Screenings: {{ quarter.count }}
          <div v-if="quarter.remarks">
            <!-- <span class="is-size-7">({{ asOf }})</span> -->
          </div>
        </div>
      </div>
    </div>
    <h3 class="is-size-4"><b>2020</b></h3>
    <br />
    <div class="columns is-multiline">
      <div class="card column is-6 quarter" v-for="quarter in quarters2020" :key="quarter.name">
        <div class="card-content">
          <h3 class="is-size-5">
            <b>{{ quarter.name }}</b>
          </h3>
          Number of Screenings: {{ quarter.count }}
          <div v-if="quarter.remarks">
            <!-- <span class="is-size-7">({{ asOf }})</span> -->
          </div>
        </div>
      </div>
    </div>
    <br />
    <h3 class="is-size-4"><b>Schools/Colleges Attended</b></h3>
    <br />
    <div class="columns is-multiline">
      <div class="card column is-6 org" v-for="org in orgs" :key="org">
        <div class="card-content">
          {{ org }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dashboard',
  components: {},
  data() {
    return {
      asOf: '',
      // numbers based on discussion with Sachin
      count2018: 2475,
      count2019: 0,
      count2020: 0,
      countTotal: 0,
      quarters: [
        {
          name: 'Q1 (Jan-Mar)',
          count: 2213,
        },
        {
          name: 'Q2 (Apr-Jun)',
          count: 2169,
        },
        {
          name: 'Q3 (Jul-Sep)',
          count: 1950,
        },
        {
          name: 'Q4 (Oct-Dec)',
          count: 2252,
          remarks: true,
        },
      ],
      quarters2020: [
        {
          name: 'Q1 (Jan-Feb)',
          count: 2230,
        },
      ],
      orgs: ['CCTE College', 'D.G.Vaishnav College', 'Don Bosco School', 'Government Girls Higher Secondary School (Ashok Nagar)', 'Grace Matriculation School', 'Hindu College', 'Jessie Mosses Higher Secondary School', 'SBOA', 'Seetha Kingston School', 'Stella Maris College'],
    };
  },
  created() {
    this.count2019 = 0;
    this.count2020 = 0;
    this.quarters.forEach((q) => {
      this.count2019 += q.count;
    });
    this.quarters2020.forEach((q) => {
      this.count2020 += q.count;
    });
    this.countTotal = this.count2018 + this.count2019 + this.count2020;
  },
};
</script>

<style scoped lang="scss">
.year2018 {
  background-image: linear-gradient(to bottom, #ffa726, white);
}

.year2019 {
  background-image: linear-gradient(to bottom, #a5d6a7, white);
}

.year2020 {
  background-image: linear-gradient(to bottom, #fff9c4, white);
}

.quarter {
  background-image: radial-gradient(#b3e5fc, white);
}

.org {
  background-image: radial-gradient(#cfd8dc, white);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue